import { z as zod } from 'zod';
import { DAYS_OF_WEEK } from './amenity-form';
import { MAX_AMENITY_DEPOSIT_AMOUNT, MAX_AMENITY_TOTAL_FEE_AMOUNT } from './amenity-payment-limits';

const dayScheduleSchema = zod.object({
  enabled: zod.boolean(),
  start: zod.string(),
  end: zod.string(),
});

export const amenitySchema = zod.object({
  name: zod.string().min(1, 'Name is required'),
  description: zod.string().optional(),
  rules: zod.string().optional(),
  fee_description: zod.string().optional(),
  deposit_amount: zod.number().min(0).max(MAX_AMENITY_DEPOSIT_AMOUNT, `Deposit cannot exceed $${MAX_AMENITY_DEPOSIT_AMOUNT.toLocaleString()}`).optional(),
  total_fee_amount: zod.number().min(0).max(MAX_AMENITY_TOTAL_FEE_AMOUNT, `Total fee cannot exceed $${MAX_AMENITY_TOTAL_FEE_AMOUNT.toLocaleString()}`).optional(),
  required_documents: zod.array(zod.string()).default([]),
  availability: zod.record(
    zod.enum(DAYS_OF_WEEK),
    dayScheduleSchema,
  ),
  seasonal_enabled: zod.boolean(),
  seasonal_start_date: zod.string().nullable().optional(),
  seasonal_end_date: zod.string().nullable().optional(),
  time_block_duration: zod.number().nullable(),
  reservation_min_duration: zod.number().min(1).nullable().optional(),
  reservation_max_duration: zod.number().min(1).nullable().optional(),
  max_guests: zod.number().min(1).nullable().optional(),
  guest_count_required: zod.boolean(),
  alcohol_question_enabled: zod.boolean(),
  requires_approval: zod.boolean().optional(),
  is_active: zod.boolean().optional(),
}).refine(
  (data) => {
    if (data.deposit_amount != null && data.total_fee_amount != null) {
      return data.deposit_amount <= data.total_fee_amount;
    }
    return true;
  },
  {
    message: 'Deposit cannot exceed the total fee',
    path: ['deposit_amount'],
  }
);
